<template>
    <div class="cup-group-stage">
        <div v-if="!cupGroups || cupGroups.length === 0" class="no-cup-data">
            <div class="no-cup-icon">🏆</div>
            <h3>Групповой этап не найден</h3>
            <p>Для выбранного сезона группы кубка еще не созданы</p>
        </div>

        <div v-else class="cup-content">
            <div class="cup-groups">
                <div v-for="group in cupGroups" :key="group.group" class="cup-group">
                    <h3 class="group-title">Группа {{ group.group }}</h3>
                    <cup-group-table :teams="group.teams" :games="getGroupGames(group.group, group.teams)" />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import CupGroupTable from '@/components/features/results/CupGroupTable.vue';

const props = defineProps({
    cupGroups: {
        type: Array,
        default: () => []
    },
    groupGames: {
        type: Array,
        default: () => []
    }
});

const getGroupGames = (group, groupTeams) => {
    if (!props.groupGames || !groupTeams || groupTeams.length === 0) return [];

    const teamIds = new Set(groupTeams.map(team => team.id));

    return props.groupGames.filter(game => {
        const homeId = game.home_team?.id;
        const awayId = game.away_team?.id;

        if (!homeId || !awayId) return false;

        return teamIds.has(homeId) && teamIds.has(awayId);
    });
};
</script>
